import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StepModel } from '@classifieds-sell/shared';
import {
    setRouterStepId,
    setRouterStepInfo,
    updateSteps
} from './router.actions';
import { StepInfo } from './router.models';
import { RouterPartialState } from './router.reducer';
import * as RouterSelectors from './router.selectors';

@Injectable()
export class RouterFacade {
    routerData$ = this.store.pipe(select(RouterSelectors.routerData));
    categoryId$ = this.store.pipe(select(RouterSelectors.currentCategoryId));
    subCategory$ = this.store.pipe(select(RouterSelectors.currentSubCategory));
    isEditOrRelistPage$ = this.store.pipe(
        select(RouterSelectors.isEditOrRelistPage)
    );
    isEditPage$ = this.store.pipe(select(RouterSelectors.isEditPage));
    listingId$ = this.store.pipe(select(RouterSelectors.listingId));

    constructor(private store: Store<RouterPartialState>) {}

    setRouterStepInfo(stepInfo: StepInfo) {
        this.store.dispatch(setRouterStepInfo({ stepInfo }));
    }

    setRouterStepId(stepId: string) {
        this.store.dispatch(setRouterStepId({ stepId }));
    }

    updateSteps(steps: StepModel[]) {
        this.store.dispatch(updateSteps({ steps }));
    }
}
